import React, { memo } from 'react';
import { RestaurantCard } from './RestaurantCard';
import { motion } from 'framer-motion';
const RESTAURANTS = [{
  name: 'Grill 211',
  url: 'https://grill211paducahky.com/',
  address: '211 Broadway · Paducah, KY',
  description: 'Fine dining and craft cocktails on historic Broadway. Expertly seared steaks, fresh seafood, and an elegant atmosphere make it the perfect destination for a memorable evening.',
  menuItems: ['Signature Ribeye Steak', 'Filet Mignon', 'Grilled Atlantic Salmon', 'Seared Sea Scallops', 'Craft Cocktail Flight'],
  menuLabel: 'Family Favorites',
  image: 'https://images.unsplash.com/photo-1544025162-d76694265947?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80'
}, {
  name: "Freddie Cheah's",
  url: 'https://freddiecheah.com/',
  address: 'Paducah, KY',
  description: 'Our signature family restaurant celebrating bold Malaysian and Thai flavors, blending generations of culinary heritage into an elevated, modern dining experience.',
  menuItems: ['Malaysian Chicken Satay', 'Thai Lettuce Wraps', 'Shrimp Dumpling', 'Malaysian Flatbread', 'Salt and Pepper Shrimp'],
  image: 'https://cdn.magicpatterns.com/uploads/mg128gZwKR5mCKCs9YHAZe/pasted-image.jpg'
}, {
  name: 'Pizza Warehouse',
  url: 'https://pizzawarehousepaducahky.com/',
  address: 'Paducah, KY',
  description: 'Made-from-scratch pizzas, wings, and Italian classics crafted daily with the freshest ingredients possible. Hearty, crowd-pleasing food for the whole family.',
  menuItems: ['Hand-Tossed Specialty Pizzas', 'Oven-Baked Stromboli', 'Jumbo Buffalo Wings', 'Classic Spaghetti & Meatballs', 'Garlic Cheese Bread'],
  menuLabel: 'Fan Favorites',
  image: 'https://images.unsplash.com/photo-1513104890138-7c749659a591?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80'
}];
export function RestaurantShowcase() {
  return <section className="py-32 px-6 md:px-12 bg-neutral-950" id="restaurants" data-id="element-74">
      <div className="max-w-7xl mx-auto" data-id="element-75">
        <motion.div className="text-center mb-24" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-76">
          <h2 className="text-sm font-medium text-amber-500 uppercase tracking-[0.3em] mb-6" data-id="element-77">
            Our Portfolio
          </h2>
          <h3 className="text-4xl md:text-5xl font-serif text-stone-50 mb-8" data-id="element-78">
            Culinary Excellence
          </h3>
          <div className="w-px h-12 bg-neutral-800 mx-auto" data-id="element-79"></div>
        </motion.div>

        <div className="flex flex-col" data-id="element-80">
          {RESTAURANTS.map((restaurant, index) => <RestaurantCard key={index} {...restaurant} index={index} data-id="element-81" />)}
        </div>
      </div>
    </section>;
}